module.exports = __webpack_public_path__ + "img/ios.85aad6d2.png";